import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getCookie } from "components/common/cookie";

import { searchPost } from "../../../../redux/modules/postSlice";

import { SearchContainer, NoResult, Result } from "./SearchPostStyle";
import PaginationSearch from "./PaginationSearch";

const SearchPost = () => {
  const textRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [keyWord, setKeyWord] = useState(""); // 검색창속 글자 그대로
  const [correctKeyWord, setCorrectKeyWord] = useState(""); // 검색완료시의 검색어
  const [postsList, setPostsList] = useState([]); // 검색결과 게시글 리스트
  const [totalLength, setTotalLength] = useState(0); // 검색결과 게시물 총 개수
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지- 1부터시작

  // 토큰값 유무 확인 후, 없으면 로그인화면으로 redirect
  const isLogin = getCookie("AccessToken") ? true : false;
  useEffect(() => {
    !isLogin && navigate("/login", { replace: true });
  }, [navigate, isLogin]);
  const searchPosts = useSelector((state) => state.post.searchPosts);
  const currentPageFunc = () => {
    setCurrentPage((prev) => prev + 1);
  };
  const setPostsListFunc = (data) => {
    setPostsList((prev) => [...prev, ...data]);
  };

  const recommendArray = [
    "트렌드",
    "영업시간",
    "근로계약서",
    "화훼기능사",
    "인테리어",
    "예식장알바",
    "세무",
    "가을꽃디자인",
    "부자재",
    "작업실쉐어",
  ];

  const onChangeKeyWord = useCallback((e) => {
    setKeyWord(e.target.value);
    setCurrentPage(1);
  }, []);

  const searchFunc = useCallback(
    // Enter로 검색
    (e) => {
      const payload = {
        keyword: keyWord.trim().replace(/ +(?= )/g, ""),
        page: currentPage,
      };
      if (e.key === "Enter") {
        setCorrectKeyWord(keyWord);
        setShow(false);
        dispatch(searchPost(payload))
          .unwrap()
          .then((res) => {
            setPostsList(res.data);
            setTotalLength(res.boardCount);
          });
      }
      return null;
    },
    [dispatch, keyWord],
  );

  const onClickSearch = useCallback(() => {
    // 돋보기 클릭검색
    const payload = {
      keyword: keyWord.trim().replace(/ +(?= )/g, ""),
      page: currentPage,
    };
    setCorrectKeyWord(keyWord);
    setShow(false);
    dispatch(searchPost(payload))
      .unwrap()
      .then((res) => {
        setPostsList(res.data);
        setTotalLength(res.boardCount);
      });
  }, [dispatch, keyWord]);

  // 추천검색어 클릭
  const onClickRecommend = useCallback(
    (e) => {
      const payload = {
        keyword: e.target.innerHTML.trim().replace(/ +(?= )/g, ""),
        page: currentPage,
      };
      setKeyWord(e.target.innerHTML);
      setCorrectKeyWord(e.target.innerHTML);
      setShow(false);
      dispatch(searchPost(payload))
        .unwrap()
        .then((res) => {
          setPostsList(res.data);
          setTotalLength(res.boardCount);
        });
    },
    [dispatch, keyWord],
  );

  const onClickReset = useCallback((e) => {
    setKeyWord("");
    setCorrectKeyWord("");
    setCurrentPage(1);
    setPostsList([]);
    setShow(true);
    setTotalLength(0);
    textRef.current.focus();
  }, []);

  return (
    <SearchContainer>
      <header>
        <img
          className="arrowBack"
          src="/img/arrowBack.svg"
          alt="arrow back"
          onClick={() => navigate(-1)}
        />
        <div className="inputSearch">
          <div>
            <img
              className="img__right"
              src="/img/searchBlack.svg"
              alt="Search icon"
              onClick={onClickSearch}
            />
          </div>
          <input
            ref={textRef}
            value={keyWord}
            onChange={onChangeKeyWord}
            type="text"
            autoFocus
            placeholder="검색어를 입력해 주세요"
            onKeyDown={searchFunc}
          />
          {keyWord.length > 0 && (
            <img
              src="/img/resetBtn.svg"
              alt="검색창 초기화"
              onClick={onClickReset}
            />
          )}
        </div>
      </header>

      <main>
        {show && (
          <>
            <h1>추천검색어</h1>
            <div>
              {recommendArray.map((v) => (
                <div key={v} className="item" onClick={onClickRecommend}>
                  {v}
                </div>
              ))}
            </div>
          </>
        )}
      </main>

      {show === false &&
        (searchPosts?.length > 0 ? (
          <Result>
            <PaginationSearch
              searchPosts={searchPosts}
              keyWord={keyWord}
              correctKeyWord={correctKeyWord}
              postsList={postsList}
              totalLength={totalLength}
              currentPage={currentPage}
              currentPageFunc={currentPageFunc}
              setPostsListFunc={setPostsListFunc}
            />
          </Result>
        ) : (
          <main>
            <NoResult>
              <h1>검색 결과가 없습니다</h1>
              <p>
                검색어를 다시 한번 확인해 보거나,
                <br />
                <span>'{correctKeyWord.trim().replace(/ +(?= )/g, "")}'</span>
                을/를 주제로 이야기 해보는건 어떨까요?
              </p>
              <Link to="/boards/createpost">
                <div>커뮤니티에 글 작성하기</div>
              </Link>
            </NoResult>
          </main>
        ))}
    </SearchContainer>
  );
};

export default SearchPost;
